<template>
	<section class="dashboard__chat-ui">
		<header class="dashboard__chat-ui__header d-flex align-items-center">
			<vs-avatar
				circle
				class="dashboard__chat-ui__header__avatar mr-3"
				size="50"
				dark
			>
				<img
					v-if="chat.profilePicture"
					:src="chat.profilePicture"
					:alt="chat.nickname"
				/>
				<template v-if="!chat.profilePicture" #text>
					{{ chat.name }}
				</template>
			</vs-avatar>
			<div
				class="dashboard__chat-ui__title-status-extra d-flex w-100 justify-content-between"
			>
				<div class="dashboard__chat-ui__title-status">
					<h6 class="m-0 dashboard__chat-ui__title text--primary">
						{{ chat.name }}
					</h6>
					<p class="m-0 dashboard__chat-ui__status text--secondary">
						{{ chat.online ? "online" : "offline" }}
					</p>
				</div>
				<div class="dashboard__chat-ui__extra d-flex">
					<button class="chat-hoverable-btn mx-1">
						<i class="fal fa-1halfx fa-search"></i>
					</button>
					<button class="chat-hoverable-btn mx-1">
						<i class="fal fa-2x fa-ellipsis-h"></i>
					</button>
				</div>
			</div>
		</header>
		<main class="dashboard__chat-ui__content w-100 position-relative">
			<transition-group name="v-fade" mode="out-in">
				<div
					v-show="messagesLoading"
					ref="messagesLoading"
					key="message-loading"
					class="loading"
				></div>
				<simplebar
					key="messages-container"
					v-show="!messagesLoading"
					ref="scrollable"
					class="h-100 dashboard__chat-ui__content__simplebar w-100"
				>
					<div
						class="pad messages__container d-flex flex-column justify-content-end"
					>
						<message
							:key="'msg' + i._id"
							v-for="i in messages"
							:i="i"
							:chat="chat"
						/>
					</div>
				</simplebar>
			</transition-group>
		</main>

		<footer
			class="dashboard__chat-ui__chat-input d-flex justify-content-between"
		>
			<div
				ref="chatInput"
				class="dashboard__chat-ui__input-file-container d-flex w-100 h-100 "
			>
				<button class="chat-hoverable-btn mr-2">
					<svg
						fill="var(--white-color2)"
						width="52"
						height="52"
						version="1.1"
						id="lni_lni-paperclip"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 64 64"
						style="enable-background:new 0 0 64 64; transform: rotate(30deg)"
						xml:space="preserve"
					>
						<g>
							<path
								d="M32.9,62.8c-0.2,0-0.3,0-0.5,0c0,0,0,0,0,0c-4.7,0-9.7-1.9-12.8-4.8c-3.3-3.1-5.1-7.3-5.1-11.6V14.2
		c0-4.3,2.1-8.2,5.8-10.6c3.6-2.5,8-3.1,12.2-1.6l0.3,0.1c0.5,0.2,1.1,0.3,1.7,0.7c4.6,2.4,7.3,6.7,7.3,11.5v27.4
		c0,2.7-0.9,5.2-2.6,7.1c-0.3,0.4-0.5,0.6-0.7,0.7c-1.8,1.7-4,2.6-6.4,2.6c-2.7,0-5.4-1.2-7.1-3.3c-1.7-2-2.6-4.5-2.6-7.2v-23
		c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8v23c0,1.8,0.6,3.6,1.8,4.9c1.1,1.3,2.7,2.1,4.4,2.1c1.5,0,2.8-0.6,3.9-1.6
		c0.1-0.1,0.2-0.2,0.4-0.5c1.1-1.3,1.8-3,1.8-4.9V14.3c0-3.6-2-6.6-5.5-8.4l-0.1-0.1c-0.2-0.1-0.5-0.2-0.9-0.4l-0.3-0.1
		c-3.2-1.1-6.5-0.6-9.2,1.2c-2.7,1.8-4.2,4.5-4.2,7.7v32.1c0,3.3,1.5,6.6,4,9.1c2.5,2.4,6.6,3.9,10.4,3.9c3.6,0.1,7.2-1.3,9.8-3.8
		c2.6-2.5,4-5.7,3.9-9.2v-25c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8v24.9c0.1,4.3-1.7,8.5-5,11.7C41.4,61,37.2,62.8,32.9,62.8z"
							/>
						</g>
					</svg>
				</button>

				<editor-content
					placeholder="Write Something."
					@keydown.enter.ctrl.native="
						increaseInputHeight($refs.chatInput)
					"
					@keydown.backspace="decreaseInputHeight($refs.chatInput)"
					class="transparent-input w-100"
					@keydown.native.enter.prevent.stop.exact="sendMessage"
					:editor="editor"
					v-model="message"
				/>
			</div>

			<div class="dashboard__chat-ui__stickers-voice d-flex">
				<button class="chat-hoverable-btn mx-1">
					<i class="fal fa-smile fa-1halfx"></i>
				</button>
				<button class="chat-hoverable-btn mx-1">
					<i class="fal fa-microphone fa-1halfx"></i>
				</button>
			</div>
		</footer>
	</section>
</template>

<script>
import simplebar from "simplebar-vue"
import tiptap from "@/components/mixins/tiptap"
import { mapState, mapMutations } from "vuex"
import Message from "./Message.vue"
let uuid = 0
export default {
	data: () => ({
		newMsg: ""
	}),
	mixins: [tiptap],
	components: {
		Message,
		simplebar
	},
	props: {
		chat: Object,
		messagesLoading: Boolean
	},
	computed: {
		...mapState(["MY_PROFILE"]),
		...mapState("sockets", ["CHATS"]),
		messages() {
			return this.CHATS[this.$route.params.nickname]
				? this.CHATS[this.$route.params.nickname]
				: []
		}
	},

	methods: {
		...mapMutations("sockets", ["ADD_MESSAGE"]),
		async scrollBottom() {
			setTimeout(() => {
				const el = this.$refs.scrollable.SimpleBar.getScrollElement()
				el.scrollTop = el.scrollHeight
			}, 0)
		},

		attachEvent() {
			this.$refs.scrollable.scrollElement.addEventListener(
				"scroll",
				this.handleScroll
			)
		},
		handleScroll() {},
		async sendMessage() {
			const message = {
				_id: uuid++,
				text: this.message,
				from: this.MY_PROFILE.nickname,
				to: this.chat.nickname,
				createdAt: Date.now()
			}
			this.ADD_MESSAGE({
				message,
				myProfile: this.MY_PROFILE
			})
			await this.$socket.emit("sendMessage", { ...message })
			this.clearContent()
			this.scrollBottom()
		},
		openLoading() {
			const target = this.$refs["messagesLoading"]
			console.log(target)
			this.$vs.loading({
				target,
				color: "#362eb8",
				type: "corners"
			})
		}
	},
	async mounted() {
		this.openLoading()
		this.sockets.subscribe("receiveMessage", async (message) => {
			console.log("new-msg")
			await this.ADD_MESSAGE({
				message,
				myProfile: this.MY_PROFILE
			})
			if (message.from === this.$route.params.nickname) {
				this.scrollBottom()
			}
		})
	},
	created() {}
}
</script>
